module.exports = __webpack_public_path__ + "img/car.6b44116b.png";